<div class="event-ticketing-skeleton">
  <div class="event-ticketing-skeleton__grid">
    <div class="event-ticketing-skeleton__card" *ngFor="let item of [1, 2, 3]">
      <!-- Card Header: Title + Checkmark -->
      <div class="event-ticketing-skeleton__header">
        <app-skeleton className="h-16 w-60% r-4"></app-skeleton>
        <app-skeleton className="h-24 w-24 r-50%"></app-skeleton>
      </div>

      <!-- Card Image -->
      <div class="event-ticketing-skeleton__image">
        <app-skeleton className="h-200 w-100% r-12"></app-skeleton>
      </div>
    </div>
  </div>
</div>
